import cookie from '@s-ui/js/lib/cookie'

const PAGINATION_PLACEHOLDER = '%{pageNumber}'
const DEFAULT_PAGINATION_PLACEHOLDER_URL = '#'

export const getInitialProps = async ({
  routeInfo,
  context: {
    cookies,
    domain,
    i18n: {culture},
    pde
  }
}) => {
  const {
    location: {pathname: path, query, search: queryParams, state},
    params: {section}
  } = routeInfo

  const {unsubscribeFavorite} = cookie.parse(cookies)

  const IS_FAVORITE_LIST = true

  const _markAsFaved = ads =>
    ads.map(adItem => ({
      ...adItem,
      isFavorite: IS_FAVORITE_LIST
    }))

  const getFavorites = async ({search}) => {
    try {
      const {
        ads = [],
        totalAds = 0,
        contracts: dealers = [],
        totalContracts: totalDealers = 0
      } = await domain.get('get_user_favorites_use_case').execute({search})

      return {
        ads: ads.map((ad, index) => ({...ad, list_position: index + 1})),
        totalAds,
        dealers,
        totalDealers
      }
    } catch (error) {
      return {ads: [], totalAds: 0, dealers: [], totalDealers: 0}
    }
  }

  const getPageName = () => domain.get('get_page_name_page_use_case').execute({path})

  const getPagination = () =>
    domain.get('get_search_pagination_url_ads_use_case').execute({
      paginationPlaceholder: PAGINATION_PLACEHOLDER,
      queryParams: query,
      url: path
    })

  const getSearchData = () =>
    domain.get('get_search_data_from_url_search_use_case').execute({path, query, url: path + queryParams})

  const [
    {
      value: {pageName}
    },
    {
      value: [paginationError, paginationUrl]
    },
    {
      value: [searchDataError, searchDataResponse]
    }
  ] = await Promise.allSettled([getPageName(), getPagination(), getSearchData()])

  const {search} = searchDataError ? {} : searchDataResponse.toFiltersSearch()

  const favorites = await getFavorites({search})

  const ads = _markAsFaved(favorites.ads)
  const dealers = _markAsFaved(favorites.dealers)

  const paginationPlaceholderUrl = paginationError ? DEFAULT_PAGINATION_PLACEHOLDER_URL : paginationUrl

  const [
    {
      value: [seoDataError, seoDataResponse]
    },
    {value: trackingDataResponse}
  ] = await Promise.allSettled([
    domain.get('get_seo_data_use_case').execute({culture, pageName}),
    domain.get('get_page_tracking_data_use_case').execute(
      section === 'dealers'
        ? {
            products: dealers,
            page: pageName
          }
        : {
            advertisements: ads,
            lastFilter: state?.lastFilter,
            page: pageName,
            search
          }
    )
  ])

  return {
    ads,
    dealers,
    totalAds: favorites.totalAds,
    totalDealers: favorites.totalDealers,
    pageName,
    helmet: seoDataResponse?.helmet || {},
    paginationPlaceholderUrl,
    seoDataError,
    showSearchSort: !searchDataError,
    search,
    pageTrackingData: trackingDataResponse || {},
    unsubscribeFavorite,
    section
  }
}
